<template>
<modal name="sendmail-dialog"
  :adaptive="true"
  :scrollable="true"
  height="auto">
  <div class="v--modal-close-top" v-loading.fullscreen.lock="fullscreenLoading">
    <el-button @click="closeDialog"
      icon="el-icon-close"
      type="text"></el-button>
  </div>
  <div class="setting" v-if="permissionType == 1">
    <div class="setting-item" style="text-align:center;">
      <p style="font-size: 140%;">完了しました！！！</p>
      <p style="font-size: 140%;">今作成した履歴書をもとに<br>プロが好条件の薬剤師の勤め先をご紹介します！</p>
      <p style="font-size: 80%;">※サポートは関東圏のみとなっております。予めご了承ください。</p>
      <p style="font-size: 80%;">東京・神奈川県・千葉・埼玉・茨城・栃木・群馬のみ対象</p>
      <br/>
      <div style="display: inline-block;min-width: 100%;text-align:center;">
        <p>
          ㈱Yagishの<router-link id="footer-link-terms" :to="{name: 'termsPage'}" target="_blank">利用規約</router-link>、<router-link id="footer-link-policy" :to="{name: 'policyPage'}" target="_blank">個人情報保護方針</router-link>
        </p>
        <p>
          ㈱アイデムの<a href="https://jobrass.com/gakusei/SCST00503" target="_blank">利用規約</a>、<a href="https://www.aidem.co.jp/policy/index.html" target="_blank">個人情報保護方針</a>
        </p>
      </div>
      <div class="text-center">
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == false"
        style="background-color:#0F9934;border-color:#0F9934;"
          @click="$eventHub.$emit('send-mail-consult');">規約に同意して試しにサポートを受けてみる</el-button>
        <el-button id="send-adtop-pdf" type="success" v-if="isSended == true"
        style="background-color:#0F9934;border-color:#0F9934;"
          @click="closeDialog();">送信しました</el-button>
      </div>
      <br/>
      <div class="text-center">
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == false" type="primary" @click="closeDialog();">サポートは受けない</el-button>
        <el-button id="send-adtop-pdf" style="background-color:#666;border-color:#666;" v-if="isSended == true" type="primary" @click="closeDialog();">閉じる</el-button>
      </div>
      <br/>
    </div>
  </div>
</modal>
</template>
<style lang="scss" src="@/assets/scss/pages/pages.scss"></style>
<style lang="scss" src="@/assets/scss/pages/setting.scss"></style>
<script>
export default {
  components: {
  },
  data: function () {
    return {
      clearLocalStorageConfirmVisible: false,
      currentFormat: {},
      formatid: '',
      previewHtml: '',
      permissionType: 1,
      isSended:false,
      fullscreenLoading:false,
      username:'',
      baite_title:'バイト',
      isAgree:false
    }
  },
  created : function(){
    const app = this
    this.$iterateStorage(function (value, key, iterationNumber) {
        //console.log all the kay/value pairs
        if (key === 'basicData') {
          app.username = value.lastName + '_' + value.firstName
        }
    }, function (err) {
        if (!err) {
            console.log('Iteration has completed');
        }
    })
  },
  computed: {
    cleanedPreviewHtml: function () {
      // PDFで文字化けするやつを変換しておく
      return this.previewHtml
    },
    pdfFormData: function () {
      const formData = new FormData()
      formData.append('app_html', this.cleanedPreviewHtml)
      formData.append('pdf_option', 'A4')
      return formData
    }
  },
  methods: {
    openDialog: function (id, html) {
      this.formatid = id
      this.previewHtml = html.$el.innerHTML
      this.$modal.show('sendmail-dialog')
      this.clearLocalStorageConfirmVisible = false
      his.permissionType = 1
    },
    closeDialog: function () {
      this.$modal.hide('sendmail-dialog')
      this.clearLocalStorageConfirmVisible = false
    },
    confirmWin: function () {
      confirm('応募するデータを送信します。よろしいでしょうか。')
    },
    clearLocalStorage: function () {
      this.$clearStorage()
      window.location = '/'
    },
    createFilename: function (ext) {
      const now = new Date()
      const prefix = process.env.VUE_APP_DOWNLOAD_FILENAME_PREFIX
      const dateString = this.$formLib.dateFormat(now, '_yyyy-mm-dd_HH-MM-ss')
      return `${prefix}${this.formatid}${dateString}.${ext}`
    },
    sendConsult: async function () {
      if (!this.$deviceLib.isOnline) {
        this.$message({
          message: '現在オフラインです。インターネットにつながってから再度お試しください',
          type: 'warning'
        })
        return
      }
      await this.$firebase.reloadToken()
      const accessToken = this.$firebase.accessToken
      if (!accessToken || !this.$firebase.user.email) {
        this.$message({
          message: 'ログインが必要です',
          type: 'warning'
        })
        return
      }
      this.fullscreenLoading = true
      const formData = this.pdfFormData
      formData.append('token', accessToken)
      formData.append('apikey', this.$firebase.config.apiKey)
      formData.append('uuid', this.$firebase.user.uid)
      formData.append('format_id', this.formatid)
      formData.append('yaginame', this.username)
      formData.append('app_flag', '')
      formData.append('filename', this.createFilename('pdf'))
      formData.append('device_flg', this.$deviceLib.isMobileDevice ? 'SP': 'PC')
      formData.append('version', '2')
      formData.append('reqflg', '2')
      const app = this
      this.$axios
        .post(this.$varuna.endPoints.sendPdfMail, formData, {timeout: 60000})
        .then(function (response) {
          app.isSended = true
          app.$message({
            duration: 0,
            showClose: true,
            dangerouslyUseHTMLString: true,
            message: `担当者からあなたのメールアドレスにスカウトが届くことがあります！`,
            type: 'info'
          })
        })
        .catch(function (error) {
          app.$message({
            message: '送信失敗しました',
            type: 'error'
          })
          app.$gtm.sendError('pdf mail', `send pdf mail failed ${error}`)
        }).finally(function () {
          app.fullscreenLoading = false
        })
    }
  },
  beforeMount: function () {
    this.$eventHub.$on('send-mail-consult', this.sendConsult)
    this.$eventHub.$on('open-sendmail-dialog', this.openDialog)
    this.$eventHub.$on('popstate', this.closeDialog)
  },
  destroyed: function () {
    this.$eventHub.$off('send-mail-consult', this.sendConsult)
    this.$eventHub.$off('open-sendmail-dialog', this.openDialog)
    this.$eventHub.$off('popstate', this.closeDialog)
  }
}
</script>
